import { render, staticRenderFns } from "./applyupgrade.vue?vue&type=template&id=9a65d562&scoped=true"
import script from "./applyupgrade.vue?vue&type=script&lang=js"
export * from "./applyupgrade.vue?vue&type=script&lang=js"
import style0 from "./applyupgrade.vue?vue&type=style&index=0&id=9a65d562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a65d562",
  null
  
)

export default component.exports